<div class="row mb-2">
  <div class="col-10">
    
    <it-chip
      [label]="'Periodo: ' + formatDateIT(selectedStartDate) + ' → ' + formatDateIT(selectedEndDate)"
      color="primary"
      class="me-2"
    ></it-chip>
    <it-chip [label]="'Pratiche: ' + (form.controls['state'].value=='OPEN' ? 'aperte' : (form.controls['state'].value=='CLOSED' ? 'chiuse' : (form.controls['state'].value=='ANNULLED' ? 'annullate' : 'tutte')))"
      color="primary"
      class="me-2"
    ></it-chip>

  </div>
  <div class="col-2 text-end">
    <button
      itButton="outline-warning"
      [size]="'xs'"
      data-bs-toggle="modal"
      data-bs-target="#filterStatsModal"
    >
      <it-icon name="search"></it-icon> Filtra dati
    </button>
  </div>
</div>

<it-table striped="true" bordered="true" class="text-center align-middle">
  <ng-container thead>
    <tr>
      <th rowspan="2" scope="col" class="top-left colored fixed">Setting</th>
      <th colspan="2" class="text-center colored">Regione</th>
      <th colspan="2" class="text-center colored">ASL 1</th>
      <th colspan="2" class="text-center colored">ASL 2</th>
      <th colspan="2" class="text-center colored">ASL 3</th>
      <th colspan="2" class="text-center colored">ASL 4</th>
    </tr>
    <tr>
      <th scope="col">Pratiche</th>
      <th scope="col">Pazienti</th>
      <th scope="col">Pratiche</th>
      <th scope="col">Pazienti</th>
      <th scope="col">Pratiche</th>
      <th scope="col">Pazienti</th>
      <th scope="col">Pratiche</th>
      <th scope="col">Pazienti</th>
      <th scope="col">Pratiche</th>
      <th scope="col">Pazienti</th>
    </tr>
  </ng-container>

  <ng-container tbody>
    <tr *ngFor="let row of sortedData">
      <td class="top-left fixed">{{ formatSetting(row.setting) }}</td>
      <td>{{ row.reg_pra }}</td>
      <td>{{ row.reg_paz }}</td>
      <td>{{ row.asl_1_pra || '0' }}</td>
      <td>{{ row.asl_1_paz || '0' }}</td>
      <td>{{ row.asl_2_pra || '0' }}</td>
      <td>{{ row.asl_2_paz || '0' }}</td>
      <td>{{ row.asl_3_pra || '0' }}</td>
      <td>{{ row.asl_3_paz || '0' }}</td>
      <td>{{ row.asl_4_pra || '0' }}</td>
      <td>{{ row.asl_4_paz || '0' }}</td>
    </tr>
  </ng-container>

  <ng-container tfoot>
    <tr class="fw-semibold">
      <td class="top-left">Totale</td>
      <td>{{ totals.total_pra }}</td>
      <td>{{ totals.total_pat }}</td>
      <td>{{ totals.asl_1_total_pra }}</td>
      <td>{{ totals.asl_1_total_pat }}</td>
      <td>{{ totals.asl_2_total_pra }}</td>
      <td>{{ totals.asl_2_total_pat }}</td>
      <td>{{ totals.asl_3_total_pra }}</td>
      <td>{{ totals.asl_3_total_pat }}</td>
      <td>{{ totals.asl_4_total_pra }}</td>
      <td>{{ totals.asl_4_total_pat }}</td>
    </tr>
  </ng-container>
</it-table>


<it-modal
  size="xl"
  #rightModal="itModal"
  alignment="right"
  scrollable="true"
  id="filterStatsModal"
>
  <ng-container modalTitle>Filtri ricerca</ng-container>

  <div class="mb-2">
    <it-card teaser="true" shadow="true">
      <h3 class="card-title h5">Periodo estrazione</h3>
      <form [formGroup]="form">
        <div class="row">
          <div class="col-12">
            <it-input
              label="Data inizio"
              [type]="'date'"
              formControlName="dataInizio"
            ></it-input>
          </div>
          <div class="col-12">
            <it-input
              label="Data fine"
              [type]="'date'"
              formControlName="dataFine"
            ></it-input>
          </div>
          <it-select
                  id="default-select"
                  label="Pratiche"
                  formControlName="state"
                >
                  <option [value]="'ALL'">Tutte</option>
                  <option [value]="'OPEN'"> Aperte</option>
                  <option [value]="'CLOSED'"> Chiuse</option>
                  <option [value]="'ANNULLED'"> Annullate</option>
                </it-select>
        </div>
        </form>
        <div class="row">
          <div class="col">
            <it-select
                  id="default-select"
                  label="Anno"
                  [(ngModel)]="year"
                  defaultOption=""
                >
                  <option [value]="null">Seleziona un anno</option>
                  <option [value]="2024"> {{ 2024 }}</option>
                  <option [value]="2025"> {{ 2025 }}</option>
                  <option [value]="2026"> {{ 2026 }}</option>
                  <option [value]="2027"> {{ 2027 }}</option>
                  <option [value]="2028"> {{ 2028 }}</option>
                  <option [value]="2029"> {{ 2029 }}</option>
                  <option [value]="2030"> {{ 2030 }}</option>
                  <option [value]="2031"> {{ 2031 }}</option>
                  <option [value]="2032"> {{ 2032 }}</option>
                  <option [value]="2033"> {{ 2033 }}</option>
                  <option [value]="2034"> {{ 2034 }}</option>
                  <option [value]="2035"> {{ 2035 }}</option>
                  <option [value]="2036"> {{ 2036 }}</option>
                </it-select>
            <it-select
                  id="default-select"
                  label="Trimestre"
                  [(ngModel)]="trimestre"
                  defaultOption=""
                  (ngModelChange)="selectedTrimester()"
                  *ngIf="year"
                >
                  <option [value]="null">Seleziona un trimestre</option>
                  <option [value]="'1'"> {{ 'Primo trimestre' }}</option>
                  <option [value]="'2'"> {{ 'Secondo trimestre' }}</option>
                  <option [value]="'3'"> {{ 'Terzo trimestre' }}</option>
                  <option [value]="'4'"> {{ 'Quarto trimestre' }}</option>
                </it-select>
          </div>
        </div>
      
    </it-card>
  </div>

  <ng-container footer>
    <button
      itButton="primary"
      size="lg"
      type="button"
      (click)="search()"
      data-bs-dismiss="modal"
      data-bs-dismiss="modal"
    >
      Filtra
    </button>
    <button
      itButton="outline-primary"
      size="lg"
      type="button"
      data-bs-dismiss="modal"
    >
      Chiudi
    </button>
  </ng-container>
</it-modal>